import React from 'react';
import ExploreCard from './ExploreCard';

export default function ExploreChoiceCard(props) {
  return <ExploreCard {...props} />;
}
